import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              每日更新漫画章节，追更不停歇
            </p>
          </div>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
          {latestComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className={`flex items-center gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer ${
                index < latestComics.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                index < 3 ? 'bg-accent-500 text-white' : 'bg-secondary-100 text-secondary-600'
              }`}>
                {index + 1}
              </span>
              <div className="w-14 h-14 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm truncate hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author} · {comic.category}</p>
              </div>
              <div className="hidden sm:flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-file-list-3-line w-3 h-3 flex items-center justify-center"></i>
                  {comic.chapters}话
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
                  {comic.rating}
                </span>
              </div>
              <span
                className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap flex-shrink-0 ${
                  comic.status === '连载中'
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {comic.status}
              </span>
              <span className="text-xs text-foreground-400 flex-shrink-0 whitespace-nowrap">
                {comic.updateDate}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}